import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Video, CheckCircle2, AlertTriangle } from "lucide-react";
import { videoConfig, saveVideoLimits } from "@/lib/videoApi";
import { CloudflareCredentials } from "@/components/video/CloudflareCredentials";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const GB = 1024 ** 3;

export function VideoSettings() {
  const [c, setC] = useState(null);
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = (d) => { setC(d); setF({ max_videos: String(d.max_videos), gb: String(+(d.max_bytes / GB).toFixed(2)), minutes: String(+(d.max_duration_seconds / 60).toFixed(1)) }); };
  useEffect(() => { videoConfig().then(load).catch(() => {}); }, []);
  if (!c) return null;
  const save = async () => {
    setBusy(true);
    try { load(await saveVideoLimits({ max_videos: parseInt(f.max_videos, 10) || 0, max_bytes: Math.round(parseFloat(f.gb) * GB) || 0, max_duration_seconds: Math.round(parseFloat(f.minutes) * 60) || 0 })); toast.success("Video limits saved"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const field = (k, label, testId) => (
    <label className="text-xs font-semibold text-stone-600">{label}
      <Input data-testid={testId} inputMode="decimal" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value.replace(/[^\d.]/g, "") })} className="mt-1 h-11 text-base" /></label>
  );
  return (
    <section data-testid="video-settings" className="rounded-xl border border-stone-200 bg-white p-5">
      <h2 className="font-semibold text-stone-900 flex items-center gap-2"><Video className="h-4 w-4 text-amber-800" /> Video Uploads</h2>
      <p data-testid="video-cf-status" className={`mt-2 text-sm flex items-start gap-2 ${c.configured ? "text-emerald-800" : "text-amber-900"}`}>
        {c.configured ? <><CheckCircle2 className="h-4 w-4 mt-0.5 shrink-0" />Cloudflare Stream credentials are set.</>
          : <><AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />Cloudflare Stream is not configured. Enter your Cloudflare Account ID and API Token (Stream: Edit) below to enable video uploads.</>}
      </p>
      <CloudflareCredentials configured={c.configured} onSaved={() => videoConfig().then(load).catch(() => {})} />
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
        {field("max_videos", "Maximum videos per horse", "video-max-count")}
        {field("gb", "Maximum file size (GB)", "video-max-gb")}
        {field("minutes", "Maximum duration (minutes)", "video-max-minutes")}
      </div>
      <Button data-testid="video-settings-save" disabled={busy} onClick={save} className="mt-3 h-11 rounded-full bg-amber-800 hover:bg-amber-900 text-white">Save Video Limits</Button>
    </section>
  );
}
